import ui from './ui';
import submission from './submission';

export default [...ui, ...submission];



// WEBPACK FOOTER //
// ./src/sagas/index.js